import React, { Component, Fragment } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import Modal from "./Modal.js";
import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable.js";
import api from "../../api/api.js";

class Loteos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Moneda Preferida",
                    id: "moneda_preferida",
                    accessor: d => d.moneda_preferida ? d.moneda_preferida.nombre : "-",
                    width: 100,
                    show: true,
                },
                {
                    Header: "Ubicación",
                    id: "direccion_completa",
                    accessor: "direccion_completa",
                    show: true,
                },
                {
                    Header: "Categoría",
                    id: "tipo",
                    accessor: d => d.tipo? d.tipo.nombre : "",
                    show: true,
                },
                {
                    Header: "Web",
                    id: "mostrarEnWeb",
                    accessor: d => d.mostrarEnWeb ?
                        <div className="btn-success text-center">Publicado</div> :
                        <div className="btn-warning text-center">No publicado</div>,
                    show: true,
                    lookup: 'exact',
                    width: 120,
                    Filter: ({ filter, onChange }) =>
                        <select
                            value={filter ? filter.value : ''}
                            onChange={e => onChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="1">Publicado</option>
                            <option value="0">No publicado</option>
                        </select>,
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: props => <Modal {...props} action="CREATE"/>,
                        permission: 'loteos_new',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="EDIT" />,
                        permission: 'loteos_edit',
                    },
                    {
                        detail: true,
                        component: props => <Modal {...props} action="DETAIL" />,
                        permission: 'loteos_detail',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="DELETE" />,
                        permission: 'loteos_delete',
                    },
                    {
                        detail: true,
                        component: props => <Modal {...props} action="LOTES" activeTab={3} />,
                        permission: 'loteos_view',
                    },
                    {
                        detail: true,
                        component: (props) =>
                            <Fragment>
                                <button
                                    disabled={!props.id()}
                                    id="generar-reporte-loteo"
                                    onClick={() => { (props.id() ? window.open(api.loteos.reporte.replace('$id_loteo', props.id())) : null) }}
                                    className="icon btn btn-secondary btn-sm h-100">
                                    <i className="fa fa-print" />
                                </button>
                                <UncontrolledTooltip placement="bottom" target="generar-reporte-loteo">
                                    Reporte
                                </UncontrolledTooltip>
                            </Fragment>,
                        permission: 'loteos_media',
                    },
                ]}
                depth={2}
                apiUrl={api.loteos.loteos}
                columns={this.state.columns}
                exportUrl={api.loteos.loteos}
                title={"Loteos"}
            />
        );
    }
}

export default Loteos;



// WEBPACK FOOTER //
// ./src/views/Loteos/Loteos.js